<div class="py-2 mt-0" ngxUiLoaderBlurred>
    <div class="col-md-12 p-0" id="dashboard">
        <section class="position-relative mt-3 mb-3">
            <div class="bg-light" style="box-shadow: 1px 1px 6px -3px;padding: 20px 6px 6px 6px;">
                <form class="form-horizontal" [formGroup]="searchForm"
                    (ngSubmit)="previous_day='';next_day='';to_day='';searchdate=''; searchsubmit()">
                    <ul class="nav nav-pills mb-3 check-custom" id="pills-tab" role="tablist">
                        <li class="nav-item position-relative mr-4">
                            <div class="custom-radio d-flex">
                                <label class="switch">
                                    <input type="checkbox" [checked]="Regularsearch == true"
                                        (click)="changetoRegular($event);">
                                    <span class="slider round"></span>
                                </label>
                                <label class="align-self-center m-0 text-dark" for="customRadio">&nbsp; Regular</label>
                            </div>
                        </li>
                        <li class="nav-item position-relative mr-4 ">
                            <div class="custom-radio d-flex">
                                <input type="radio" class="align-self-center" *ngIf="Regularsearch == true" name="oneway"  id="customRadio" value="oneway" [checked]="true">
                                <input type="radio" class="align-self-center" *ngIf="Regularsearch == false" name="oneway"
                                    (click)="this.flightdetails='';this.searchresult =false;this.searchForm.reset();this.Departurecity_DATA.length=0;Change_Status('oneway'); "
                                    id="customRadio" value="oneway" [checked]="true">
                                <label class="align-self-center m-0" for="customRadio">&nbsp; One Way</label>
                            </div>
                        </li>
                        <li class="nav-item position-relative">
                            <div class="custom-radio d-flex">
                                <input type="radio" class="align-self-center" name="oneway"  [disabled]="Regularsearch"
                                    (click)="this.flightdetails='';this.searchresult =false;this.searchForm.reset();this.Departurecity_DATA.length=0;Change_Status('return');changestatus('return_date_input');"
                                    id="customRadio2" value="return">
                                <label class="align-self-center m-0" for="customRadio2">&nbsp; Return</label>
                            </div>
                        </li>
                        <!-- <span class="filter-cs" *ngIf="flightdetails" (click)="openNav()"><i class="fa fa-filter"></i> Filter</span> -->
                    </ul>
                    <div class="row m-0 bkg-search" style="align-items: flex-start;">
                        <div class="col-lg-5 col-sm-12 p-0">
                            <div class="row m-0">
                                <div class="col-md-6 mb-2 align-self-start position-relative">
                                    <label class="control-label mb-1">Departure City</label>
                                    <ng-select2 [data]="departure_city_data" *ngIf="Regularsearch == false" [options]="options"
                                        formControlName="departure_city_code" [tags]="true"
                                        (valueChanged)="this.searchForm.patchValue({ arrival_city_id:''});changestatus('arrivaldate_input');arrival_city_list($event);"
                                        class="mySelect-Span w-100" required placeholder="Select Departure City"></ng-select2>                           

                                    <input type="text" class="form-control" placeholder="Select Departure City" *ngIf="Regularsearch ==true"  formControlName="saerchdep" (keyup)="SearchCity()" (click)="chngoption()"/>
                                    <div class="myRegularCss" *ngIf="showoption == true">
                                        <ul>
                                            <li class="opclass" *ngFor="let dc of departure_city_data;let i = index" (click)="this.searchForm.patchValue({ arrival_city_id:''});changestatus('arrivaldate_input');arrival_city_list(dc.id);"><span>{{dc?.text}}</span><span style="float:right">{{dc?.depcode}}</span></li>
                                        </ul>
                                    </div> 

                                    <div *ngIf="searchForm.get('departure_city_code').errors && submitted">
                                        <span *ngIf="searchForm.get('departure_city_code').errors?.required" class="text-danger ft-12"> Departure City is Required</span>
                                    </div>  
                                </div>
                                <div class="col-md-6 mb-2 align-self-start position-relative">
                                    <label class="control-label mb-1">Arrival City</label>

                                    <input type="text" *ngIf="Regularsearch ==true" class="form-control" placeholder="Select Arrival City"  formControlName="searcharr" (keyup)="SearchArrCity()" (click)="this.showoption=false;this.chngoption1()"/>
                                    <div class="myRegularCss" *ngIf="showoption1 == true">
                                        <ul>
                                            <li class="opclass" *ngFor="let ac of arrival_city_data;let i = index" (click)="changestatus('departure_date');arrival_date(ac?.id);"><span>{{ac?.text}}</span><span style="float:right">{{ac?.depcode}}</span></li>
                                        </ul>
                                    </div>
                                    <ng-select2 [data]="arrival_city_data" *ngIf="Regularsearch == false" [options]="options1"
                                        formControlName="arrival_city_code" 
                                        (valueChanged)="changestatus('departure_date');arrival_date($event);"
                                        class="mySelect-Span w-100" required placeholder="Select Arrival City"></ng-select2>
                                    <div *ngIf="searchForm.get('arrival_city_code').errors && submitted">
                                        <span *ngIf="searchForm.get('arrival_city_code').errors?.required"
                                            class="text-danger ft-12">
                                            Arrival City is Required</span>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="col-lg-2 col-sm-6 mb-2 align-self-start">
                            <label class="control-label mb-1">Departure Date</label>
                            <label class="m-0 p-0" style="background-color:#fff !important">
                                <mat-form-field appearance="fill">
                                    <input matInput [matDatepickerFilter]="myFilter1" [min]="minDate?minDate:todayDate" readonly
                                        [disabled]="!departure_date" formControlName="departure_date" [max]="maxDate"
                                        (dateChange)="changestatus('traveller_input');set_d_date($event.target.value);"
                                        [matDatepicker]="picker" placeholder="DD-MM-YYYY">
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>
                                </mat-form-field>
                                <div *ngIf="searchForm.get('departure_date').errors && submitted">
                                    <span *ngIf="searchForm.get('departure_date').errors?.required"
                                        class="text-danger ft-12" style="width:164px;float:left;">
                                        Departure Date is Required</span>
                                </div>
                            </label>
                        </div>
                        <div class="col-lg-2 col-sm-6 mb-2 align-self-start">
                            <label class="control-label mb-1">Return Date</label>
                            <label class="m-0 p-0" style="background-color:#fff !important">
                                <mat-form-field appearance="fill" id="return_date"
                                    [attr.disabled]="disableInput?'':null">
                                    <input matInput [matDatepickerFilter]="myFilter" formControlName="return_date"
                                        [min]="return_min_date" [max]="return_max_date" readonly
                                        [matDatepicker]="picker1" [disabled]="!return_date_input"
                                        placeholder="DD-MM-YYYY" (dateChange)="set_r_date($event.target.value);">
                                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                    <mat-datepicker #picker1></mat-datepicker>
                                </mat-form-field>
                                <div
                                    *ngIf="submitted && flighttype == 'return' && searchForm.get('return_date').value == ''">
                                    <span class="text-danger ft-12">
                                        Return Date is Required</span>
                                </div>
                            </label>
                        </div>
                        <div class="col-lg-2 col-sm-6 mb-2 align-self-start">
                            <label class="control-label mb-1">Travellers</label>
                            <input type="text" class="form-control" style="background-color:#fff !important;" readonly
                                formControlName="travellers" [disabled]="!traveller_input" (click)="open_popup()"
                                id="travellers" placeholder="Travellers">
                        </div>
                        <div class="col-lg-1 col-sm-6 p-0 text-center align-self-start">
                            <label class="mb-1 w-100">&nbsp;</label>
                            <button class="btn btn-primary" [disabled]="this.flighttype == 'return' && this.searchForm.get('return_date').value == ''" type="submit" style="padding: 6.5px 13px;">Search</button>
                        </div>
                    </div>
                </form>
            </div>
            <div class="row m-0 mt-2" *ngIf="flightdetails && flighttype =='one_way'" >
                <div class="col-lg-4 col-md-4 col-sm-4 text-left mt-1">
                    <h6 *ngIf="previous_day != ''"><span class="badge badge-warning"><a herf="#"
                                style="cursor: pointer;" (click)="setsearchdate(previous_day.flight_date)"><i
                                    class="fa fa-caret-left"></i> {{previous_day.flight_date | date:'dd/MM/yyyy'}}
                            </a></span></h6>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 text-center mt-1">
                    <h6><span class="badge badge-warning"><a herf="#" (click)="setsearchdate(to_day)">{{to_day |
                                date:'dd/MM/yyyy' }} </a></span></h6>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 text-right mt-1">
                    <h6 *ngIf="next_day != ''"><span class="badge badge-warning"><a herf="#" style="cursor: pointer;"
                                (click)="setsearchdate(next_day.flight_date)"> {{next_day.flight_date |
                                date:'dd/MM/yyyy'}} <i class="fa fa-caret-right"></i></a></span></h6>
                </div>
            </div>

        </section>
    </div>
   
</div>
<div class="col-sm-12 mb-2" *ngIf="fitSearchCounter > 0">
    <div class="loader">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
    </div>
</div>
<div class="row m-0" *ngIf="!flightdetails" style="height: 82vh;background-image:url('assets/images/bgImgAdmin.png');background-repeat: no-repeat;background-position: center center;"></div>
<div class="row m-0">
    <div class="col-sm-3 mb-3 pl-0" *ngIf="Regularsearch == true">

        <div class="col-md-12 bg-white secondToolbar" [ngClass]="{'mat-elevation-z5' : true, 'sticky' : isSticky}" #sidenav  *ngIf="flightdetails">
            <!-- <a href="javascript:void(0)" class="closebtn" (click)="closeNav()">&times;</a> -->
    
            <div class="col-sm-12 p-0 pb-2" *ngIf="flightdetails">
                <label for="customRange3" class="col-12 form-label tooltip">Price range</label>
                <input type="range" class="col-12 form-range" min="0" max="50000"  id="customRange3" [(ngModel)]="filterprice" (change)="filter()">
                <span class="tooltiptext">Price :{{filterprice}}</span>
            </div>
            <!-- <div class="col-12 d-flex  > -->
                <div class="col-sm-12 p-0 pb-2">
                    <div class="headingFilter"><i class="fa fa-arrow-right"></i> Outbound Flight Times:</div>
                    <div class="filterConent1">
                        <label class="mb-0 text-dark w-100" *ngFor="let tm of Timings;let i = index">
                            <section class="example-section" >
                                <mat-checkbox class="p-1"   [(ngModel)]="tm.is_selected"  name="head-bnr3" (change)="filter()" >{{ tm.name }}</mat-checkbox>
                            </section>
                        </label>
                    </div>
                </div>
                <div class="col-sm-12 p-0 pb-2">
                    <div class="headingFilter"><i class="fa fa-arrow-right"></i> Inbound Flight Times:</div>
                    <div class="filterConent1">
                        <label class="mb-0 text-dark w-100" *ngFor="let intm of InTimings;let i = index">
                            <section class="example-section" >
                                <mat-checkbox class="p-1"   [(ngModel)]="intm.is_selected"  name="head-bnr3" (change)="filter()" >{{ intm.name }}</mat-checkbox>
                            </section>
                        </label>
                    </div>
                </div>
                <div class="col-sm-12 p-0 pb-2">
                    <div class="headingFilter"><i class="fa fa-arrow-right"></i> Airlines: </div>
                    <div class="filterConent1">
                        <!-- <label class="mb-0 text-dark w-100"><input type="checkbox" class=""/> SpiceJet (SG)</label>  -->
                        <label class="mb-0 text-dark w-100" *ngFor="let air of Airlines;let i = index">
                            <section class="example-section" >
                                <mat-checkbox class="p-1"   [(ngModel)]="air.is_selected"  name="head-bnr3" (change)="filter()" >{{ air.name }}</mat-checkbox>
                            </section>
                        </label>
                    </div> 
                </div>
                <div class="col-sm-12 p-0 pb-2">
                    <div class="headingFilter"><i class="fa fa-arrow-right"></i> Stops: </div>
                    <div class="filterConent1">
                        <label class="mb-0 text-dark w-100">No of Stops 
                            <section class="example-section" >
                                <mat-checkbox class="p-1"  *ngFor="let st of Stops;let i = index" [(ngModel)]="st.is_selected"  name="head-bnr3" (change)="filter()" >{{ st.name }}</mat-checkbox>
                            </section>
                        </label>
                    </div>
                </div> 
    
                <div class="col-sm-12 p-0 pb-2">
                    <div class="headingFilter"><i class="fa fa-arrow-right"></i>Popular Filter</div>
                    <div class="filterConent1">
                        <label class="mb-0 text-dark w-100">
                            <section class="example-section" >
                                <mat-checkbox class="p-1"  [(ngModel)]="Refundable.is_selected"  name="head-bnr3" (change)="filter()" >{{ Refundable.name }}</mat-checkbox>
                            </section>
                        </label>
                    </div>
                </div> 
            <!-- </div> -->
        </div>
    
        <!-- <div class=" col-sm-12 bg-light p-4 mb-3 d-flex justify-content-center" *ngIf="!flightdetails && searchresult == true">
            <div class="">
                <h3 style="color:#9a7357"> Result Not Found </h3>
            </div>
        </div> -->
        
        <div class="row m-0 mb-3 d-none" *ngIf="flightdetails">
            <div>
                <label class="m-0 mr-2 ml-2 ">No of Stops 
                    <section class="example-section" >
                        <mat-checkbox class="example-margin m-0 p-1"  *ngFor="let st of Stops;let i = index" [(ngModel)]="st.is_selected"  name="head-bnr3" (change)="filter()" >{{ st.name }}</mat-checkbox>
                    </section>
                </label>
            </div>
            <div>
                <label class="m-0 mr-2 ml-2 ">Airlines 
                        <section class="example-section" >
                            <mat-checkbox class="example-margin m-0 p-1"  *ngFor="let air of Airlines;let i = index" [(ngModel)]="air.is_selected"  name="head-bnr3" (change)="filter()" >{{ air.name }}</mat-checkbox>
                        </section>
                </label>
            </div>
            <div>
                <label class="m-0 mr-2 ml-2 ">Destination 
                        <section class="example-section" >
                            <mat-checkbox class="example-margin m-0 p-1"  *ngFor="let des of Destinations;let i = index" [(ngModel)]="des.is_selected"  name="head-bnr3" (change)="filter()" >{{ des.name }}</mat-checkbox>
                        </section>
                </label>
            </div>
            <div></div>
        </div>

    </div>
   
    <div class="p-0 mb-3" *ngIf="flightdetails" [ngClass]="Regularsearch? 'col-sm-9':'col-sm-12'"> 

        <!-- <app-filter
        [list]="filterList" 
        (onFilterChange)="filterChange($event)" >
        </app-filter> -->
        <div class="row m-0 mb-3" *ngFor="let flight of flightdetails;let i = index">
            <div class="col-sm-12 p-0">
                <div class="row m-0 justify-content-between">
                    <div class="col-" *ngIf="flight?.user_details?.company_name != undefined"><span class="comp-name">{{flight?.user_details?.company_name}}</span>
                    </div>
                    <div class="col-" *ngIf="flight?.user_details?.company_name == undefined"><span class="comp-name">{{flight?.user_details}}</span>
                    </div>
                    <div class="col- part-cs"
                        *ngIf="flight?.inventory_user_Type == 'Patner' && (flight?.creditlmitAmount < flight?.total_payable_price)">
                        <span class="text-white ft-12">Low Balance of Rs. {{flight?.creditlmitAmount}}. Recharge to
                            enable booking</span>
                    </div>
                    <div class="col- part-cs ft-12"
                        *ngIf="(flight.creditlmitAmount < flight.total_payable_price) && flight.newCal2">
                        Only {{flight.newCal3}} seats can be booked online. To proceed please change the number of
                        Travellers to max {{flight.newCal3}}.
                    </div>
                </div>
                <div class="row m-0 w-100" style="box-shadow: 0 5px 12px rgb(0 0 0 / 8%), 0 3px 12px rgb(0 0 0 / 8%);overflow:auto;border-radius:0.70rem ;">
                    <table class="table dataTable bg-white mb-0 mytbl">
                        <thead class="text-center" *ngIf="i==0">
                            <th style="width:150px;">Airline</th>
                            <th style="width:100px;">Available</th>
                            <th >Departure Details</th>
                            <th>&nbsp;</th>
                            <th>Arrival Details</th>
                            <th>Amount </th>
                        </thead>
                        <tbody>
                            <tr class="odd">
                                <td style="display: none;" valign="top" colspan="7" class="dataTables_empty">No data
                                    available in table</td>
                            </tr>
                        
                            <tr class="odd">
                                <td style="width:150px;">
                                    <img src="{{imagesrc}}/{{flight?.airlines_logo}}" alt="Image  Not Found"
                                        onerror="this.src='assets/images/noimage.png'"
                                        width="100%" height="100px" class="img-box"><br />
                                    <label class="w-100 m-0 ft-12 textclr float-left"
                                        style="margin-bottom: -5px !important;">{{ flight?.airline_name }}</label>
                                    <label class="w-100 m-0 ft-12 textclr">{{flight?.flight_number}}</label>
                                </td>
                                <td rowspan="2" *ngIf="flight.is_return ==1 " class="ft-12" style="width:100px;">
                                    <p class="m-0 p-0 ft-24" style="line-height:20px;margin-top: 10px !important">
                                        {{flight?.total_available_seats}}</p> Seats
                                </td>
                                <td *ngIf="flight.is_return == 0" class="ft-12">
                                    <p class="m-0 p-0 ft-24" style="line-height:20px;margin-top: 10px !important">
                                        {{flight?.total_available_seats}}</p> Seats
                                </td>
                                <td>
                                    <!-- <div class="row m-0">
                                        <div class="col-md-6 p-0 align-self-center">
                                            <label class="m-0 fw-500">{{flight?.departure_city_name}}</label> <br />
                                            <label class="m-0 ft-12 textclr">{{flight?.departure_airport_code}}</label>
                                            <br />
                                            <label class="m-0 ft-12 textclr"
                                                *ngIf="flight.departure_terminal_no">Terminal :
                                                {{flight?.departure_terminal_no}}</label>
                                        </div>
                                        <div class="col-md-6 p-0 align-self-center">
                                            <label class="m-0 fw-500">{{flight?.departure_date |
                                                date:'dd/MM/yyyy'}}</label> <br />
                                            <label class="m-0 ft-12 textclr">{{flight?.departure_time}}</label>
                                        </div>
                                    </div> -->
                                    <div class="row m-0">
                                        <div class="col-md-12 p-0 align-self-center">
                                            <label class="m-0 ft-24 textclr fw-500">{{flight?.departure_time}}</label><br />
                                            <label class="m-0 fw-500">{{flight?.departure_date |
                                                date:'dd/MM/yyyy'}}</label> 
                                            <!-- <br /><label class="m-0 ft-12 textclr">{{flight?.departure_airport_code}}</label> -->
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="myEvnt">
                                        <span class="myDep">{{flight?.departure_airport_code}} <img src="assets/images/plane_dep.webp" style="width: 20px;margin-left: 5px;"/></span>
                                    <label class="m-0 p-0 ft-12 textclr" *ngIf="flight?.duration == undefined || flight?.duration == '0'"
                                        [innerHTML]="durationdiff(flight.departure_time,flight.arrival_time,flight.departure_date,'oneway')">Duration</label>
                                    <label class="m-0 p-0 ft-12 textclr" *ngIf="flight?.duration != undefined && flight?.duration != '0'"
                                        [innerHTML]="duration(flight.duration)">Duration</label><span *ngIf="flight?.next_day==1" style="font-size: 14px;color: #16b516;padding-left: 5px;">+1</span><br />
                                    <label class="m-0 border-top ft-12 textclr" style="width:120px;"
                                        *ngIf="(flight?.stop_data).length != 0">Stops :
                                        {{(flight?.stop_data).length}}</label>
                                    <label class="m-0 border-top ft-12 textclr" style="width:120px;"
                                        *ngIf="(flight?.stop_data).length == 0">Non-stop</label>
                                        <span class="myArr"><img src="assets/images/plane_arr.webp" style="width: 21px;margin-right: 5px;"/> {{flight?.arrival_airport_code}}</span>
                                    </div>
                                </td>
                                <td>
                                    <!-- <div class="row m-0">
                                        <div class="col-md-6 p-0 align-self-center">
                                            <label class="m-0 fw-500">{{flight?.arrival_date | date:'dd/MM/yyyy'
                                                }}</label><br />
                                            <label class="m-0 ft-12 textclr">{{flight?.arrival_time}}</label>
                                        </div>
                                        <div class="col-md-6 p-0 align-self-center">
                                            <label class="m-0 fw-500">{{flight?.arrival_city_name}}</label> <br />
                                            <label
                                                class="m-0 ft-12 textclr">{{flight?.arrival_airport_code}}</label><br />
                                            <label class="m-0 ft-12 textclr" *ngIf="flight.arrival_terminal_no">Terminal
                                                : {{flight?.arrival_terminal_no}}</label>
                                        </div>
                                    </div> -->
                                    <div class="row m-0">
                                        <div class="col-md-12 p-0 align-self-center">
                                            <label class="m-0 ft-24 textclr fw-500">{{flight?.arrival_time}}</label><br/>
                                            <label class="m-0 fw-500">{{flight?.arrival_date | date:'dd/MM/yyyy'}} </label>
                                            <!-- <br/><label class="m-0 fw-500 textclr">{{flight?.arrival_airport_code}}</label>  -->
                                        </div>
                                    </div>
                                </td>
                                <td class="ft-12 fw-500" *ngIf="flight.is_return == '0'">
                                    <p class="m-1 p-0 ft-20"><i class="fa fa-rupee"></i> {{flight?.final_pay_amount}}</p>
                                    <span
                                    *ngIf="!((flight?.inventory_user_Type == 'Patner' || flight?.inventory_user_Type == 'partner') && flight?.creditlmitAmount < flight?.total_payable_price)">
                                        <button class="btn btn-sm btn-primary ft-12" (click)="showcompany(flight?.user_details?.company_name);bookflight(flight);">Book Now</button>
                                    </span>
                                    <span
                                        *ngIf="(flight?.inventory_user_Type == 'Patner' || flight?.inventory_user_Type == 'partner') && flight?.creditlmitAmount < flight?.total_payable_price">
                                        <button class="btn btn-sm btn-secondary ft-12" (click)="showcompany(flight?.user_details?.company_name);contactSupport();">Book Offline</button>
                                    </span>
                                </td>
                                <td class="ft-12 fw-500" rowspan="2" *ngIf="flight.is_return == '1'">
                                    <p class="m-1 p-0 ft-20"><i class="fa fa-rupee"></i> {{flight?.final_pay_amount}}</p>
                                    <span
                                        *ngIf="!((flight?.inventory_user_Type == 'Patner' || flight?.inventory_user_Type == 'partner') && flight?.creditlmitAmount < flight?.total_payable_price)">
                                        <button class="btn btn-sm btn-primary ft-12" (click)="bookflight(flight);">Book Now</button>
                                    </span>
                                    <span
                                        *ngIf="(flight?.inventory_user_Type == 'Patner' || flight?.inventory_user_Type == 'partner') && flight?.creditlmitAmount < flight?.total_payable_price">
                                        <button class="btn btn-sm btn-secondary ft-12" (click)="contactSupport();">Book Offline</button>
                                    </span>
                                </td>
                                <!-- <td style="font-size: 12px;line-height: 14px;" *ngIf="flight.is_return == 0 ">
                                    <span
                                        *ngIf="flight?.inventory_user_Type == 'Patner' && (flight?.creditlmitAmount <= flight?.total_payable_price_with_travellers)">
                                        <button class="btn btn-sm btn-secondary ft-12" disabled="true">Book Now</button>
                                    </span>
                                    <span
                                        *ngIf="flight?.inventory_user_Type == 'Patner' && (flight?.creditlmitAmount > flight?.total_payable_price_with_travellers)">
                                        <button class="btn btn-sm btn-primary ft-12" (click)="bookflight(flight)">Book
                                            Now</button>
                                    </span>
                                    <span
                                        *ngIf="flight?.inventory_user_Type != 'Patner' && (flight?.creditlmitAmount > flight?.total_payable_price)">
                                        <button class="btn btn-sm btn-primary ft-12" (click)="bookflight(flight)">Book
                                            Now</button>
                                    </span>
                                    <span *ngIf="flight?.inventory_user_Type == 'self'">
                                        <button class="btn btn-sm btn-primary ft-12" (click)="bookflight(flight)">Book
                                            Now</button>
                                    </span>
                                    ___________
                                    
                                    <span
                                        *ngIf="!((flight?.inventory_user_Type == 'Patner' || flight?.inventory_user_Type == 'partner') && flight?.creditlmitAmount < flight?.total_payable_price)">
                                        <button class="btn btn-sm btn-primary ft-12" (click)="showcompany(flight?.user_details?.company_name);bookflight(flight);">Book Now</button>
                                    </span>
                                    <span
                                        *ngIf="(flight?.inventory_user_Type == 'Patner' || flight?.inventory_user_Type == 'partner') && flight?.creditlmitAmount < flight?.total_payable_price">
                                        <button class="btn btn-sm btn-secondary ft-12" (click)="showcompany(flight?.user_details?.company_name);contactSupport();">Book Offline</button>
                                    </span>
                                </td> -->
                                <!-- <td rowspan="2" style="font-size: 12px;line-height: 14px;"
                                    *ngIf="flight.is_return ==1 ">
                                     <span
                                        *ngIf="flight?.inventory_user_Type == 'Patner' && (flight?.creditlmitAmount < flight?.total_payable_price_with_travellers)">
                                        <button class="btn btn-sm btn-secondary ft-12" disabled="true">Book Now</button>
                                    </span>
                                    <span
                                        *ngIf="flight?.inventory_user_Type == 'Patner' && (flight?.creditlmitAmount > flight?.total_payable_price_with_travellers)">
                                        <button class="btn btn-sm btn-primary ft-12" (click)="bookflight(flight)">Book
                                            Now</button>
                                    </span>
                                    <span
                                        *ngIf="flight?.inventory_user_Type != 'Patner' && (flight?.creditlmitAmount > flight?.total_payable_price)">
                                        <button class="btn btn-sm btn-primary ft-12" (click)="bookflight(flight)">Book
                                            Now</button>
                                    </span>
                                    <span *ngIf="flight?.inventory_user_Type == 'self'">
                                        <button class="btn btn-sm btn-primary ft-12" (click)="bookflight(flight)">Book
                                            Now</button>
                                    </span> 
                                    _____________
                                    <span
                                        *ngIf="!((flight?.inventory_user_Type == 'Patner' || flight?.inventory_user_Type == 'partner') && flight?.creditlmitAmount < flight?.total_payable_price)">
                                        <button class="btn btn-sm btn-primary ft-12" (click)="bookflight(flight);">Book Now</button>
                                    </span>
                                    <span
                                        *ngIf="(flight?.inventory_user_Type == 'Patner' || flight?.inventory_user_Type == 'partner') && flight?.creditlmitAmount < flight?.total_payable_price">
                                        <button class="btn btn-sm btn-secondary ft-12" (click)="contactSupport();">Book Offline</button>
                                    </span>
                                </td> -->
                            </tr>
                            <tr class="odd" *ngIf="flight.is_return ==1 ">
                                <td>
                                    <img src="{{imagesrc}}/{{flight?.airlines_logo}}" alt="Image  Not Found"
                                        onerror="this.src='assets/images/noimage.png'"
                                        width="100%" height="100px" class="img-box"><br />
                                    <label class="w-100 m-0 ft-12 textclr float-left"
                                        style="margin-bottom: -5px !important;">{{ flight?.airline_name }}</label>
                                    <label
                                        class="w-100 m-0 ft-12 textclr">{{flight?.return_flight_data?.return_flight_number}}</label>
                                </td>
                                <td>
                                    <!-- <div class="row m-0">
                                        <div class="col-md-6 p-0 align-self-center">
                                            <label
                                                class="m-0 fw-500">{{flight?.return_flight_data.return_departure_city_name}}</label>
                                            <br />
                                            <label
                                                class="m-0 ft-12 textclr">{{flight?.return_flight_data.return_departure_airport_code}}</label><br />
                                            <label class="m-0 ft-12 textclr"
                                                *ngIf="flight.return_flight_data.return_departure_city_name">Terminal :
                                                {{flight?.return_flight_data.return_departure_terminal_no}}</label>
                                        </div>
                                        <div class="col-md-6 p-0 align-self-center">
                                            <label
                                                class="m-0 fw-500">{{flight?.return_flight_data?.return_departure_date |
                                                date :'dd/MM/yyyy'}}</label> <br />
                                            <label class="m-0 ft-12 textclr">{{flight?.return_flight_data?.return_departure_time}}</label>
                                        </div>
                                    </div> -->
                                    <div class="row m-0">
                                        <div class="col-md-12 p-0 align-self-center">
                                            <label class="m-0 ft-24 fw-500 textclr">{{flight?.return_flight_data?.return_departure_time}}</label><br/>
                                            <label class="m-0 fw-500">{{flight?.return_flight_data?.return_departure_date | date :'dd/MM/yyyy'}}</label> <br />
                                            <label class="m-0 ft-12 textclr">{{flight?.return_flight_data.return_departure_airport_code}}</label><br />
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <label class="m-0 p-0 ft-12 textclr" *ngIf="flight?.return_flight_data?.return_duration == undefined || flight?.return_flight_data?.return_duration == '0'"
                                        [innerHTML]="durationdiff(flight?.return_flight_data?.return_departure_time,flight?.return_flight_data?.return_arrival_time,flight.return_flight_data.return_departure_date,'return')">Duration</label>
                                    <label class="m-0 p-0 ft-12 textclr" *ngIf="flight?.return_flight_data?.return_duration != undefined && flight?.return_flight_data?.return_duration != '0'"
                                        [innerHTML]="duration(flight?.return_flight_data?.return_duration)">Duration</label> <span *ngIf="flight?.next_day==1" style="font-size: 14px;color: #16b516;padding-left: 5px;">+1</span>
                                    <br />
                                    <label class="m-0 border-top ft-12 textclr"
                                        *ngIf="(flight?.return_stop_data).length != 0">Stops :
                                        {{(flight?.return_stop_data).length}}</label>
                                    <label class="m-0 border-top ft-12 textclr"
                                        *ngIf="(flight?.return_stop_data).length == 0">Non-stop</label>
                                </td>
                                <td>
                                    <!-- <div class="row m-0">
                                        <div class="col-6 p-0 align-self-center">
                                            <label class="m-0 fw-500">{{flight?.return_flight_data?.return_arrival_date | date :'dd/MM/yyyy'}}</label><br />
                                            <label
                                                class="m-0 ft-12 textclr">{{flight?.return_flight_data.return_arrival_time}}</label>
                                        </div>
                                        <div class="col-md-6 p-0 align-self-center">
                                            <label
                                                class="m-0 fw-500">{{flight?.return_flight_data.return_arrival_city_name}}</label>
                                            <br />
                                            <label
                                                class="m-0 ft-12 textclr">{{flight?.return_flight_data.return_arrival_airport_code}}</label><br />
                                            <label class="m-0 ft-12 textclr"
                                                *ngIf="flight.return_flight_data.return_arrival_terminal_no">Terminal :
                                                {{flight?.return_flight_data.return_arrival_terminal_no}}</label>
                                        </div>
                                    </div> -->
                                    <div class="row m-0">
                                        <div class="col-12 p-0 align-self-center">
                                            <label class="m-0 ft-24 fw-500 textclr">{{flight?.return_flight_data.return_arrival_time}}</label><br />
                                            <label class="m-0 fw-500">{{flight?.return_flight_data?.return_arrival_date | date :'dd/MM/yyyy'}}</label><br />
                                            <label class="m-0 ft-12 textclr">{{flight?.return_flight_data.return_arrival_airport_code}}</label>
                                        </div>
                                    </div>
                                </td>

                            </tr>
                            <tr *ngIf="flight?.live_pnr=='0'"><td class="text-right ft-10" style="padding:3px !important;background: #e9a03263;" colspan="7"><span class="ft-12" style="float: right;margin-right: 30px;">Booking confirmation will take a minimum of 30 Minutes.</span></td></tr>
                            <tr style="right: 20px;bottom: 0;z-index: 99;">
                                <td colspan="7" class="text-right p-0" style="padding:0px !important">
                                    <a
                                    data-toggle="collapse" [href]="'#collapseExample'+i" role="button"
                                    aria-expanded="false" aria-controls="collapseExample" class="mr-4 red cursorp"
                                    style="float:right;margin-top: -1px;right: 2px;"> View More..</a>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="7" class="p-0" style="padding:0px !important;">
                                    <div class="row m-0 collapse" [id]="'collapseExample'+i"
                                        style="background: #f1f1f1;border: 1px solid #ddd;">
                                        <div class="col-md-6">
                                            <h6 class="text-left pt-2" style="font-size:14px">Baggage Details</h6>
                                            <table class="table border text-center mytbl2">
                                                <thead>
                                                    <th>
                                                        &nbsp;
                                                    </th>
                                                    <th>
                                                        <div class="fw-500">Adult</div>
                                                        <div class="m-0" style="margin-top: -5px !important;"><label
                                                                class="ft-12 textclr fw-400 m-0">Age 12+ yrs</label>
                                                        </div>
                                                    </th>
                                                    <th>
                                                        <div class="fw-500">Children</div>
                                                        <div class="m-0" style="margin-top: -5px !important;"><label
                                                                class="ft-12 textclr fw-400 m-0">Age 2-12 yrs </label>
                                                        </div>
                                                    </th>
                                                    <th>
                                                        <div class="fw-500">Infant</div>
                                                        <div class="m-0" style="margin-top: -5px !important;"><label
                                                                class="ft-12 textclr fw-400 m-0">Age 0-2 yrs </label>
                                                        </div>
                                                    </th>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td class="text-left fw-500 p-1">Check-in</td>
                                                        <td>{{flight?.check_in_baggage_adult}} Kg</td>
                                                        <td>{{flight?.check_in_baggage_children}} Kg</td>
                                                        <td>{{flight?.check_in_baggage_infant}} Kg</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-left fw-500 p-1">Cabin</td>
                                                        <td>{{flight?.cabin_baggage_adult}} Kg</td>
                                                        <td>{{flight?.cabin_baggage_children}} Kg</td>
                                                        <td>{{flight?.cabin_baggage_infant}} Kg</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="col-md-6">
                                            <h6 class="text-left pt-2" style="font-size:14px">Stop Details</h6>
                                            <table class="table border text-center mytbl2">
                                                <thead style="line-height:35px;">
                                                    <th>
                                                        &nbsp;
                                                    </th>
                                                    <th>
                                                        <div class="fw-500">City</div>
                                                    </th>
                                                    <th>
                                                        <div class="fw-500">Layover Duration</div>
                                                    </th>
                                                </thead>
                                                <tbody>
                                                    <ng-container *ngIf="(flight?.stop_data).length > 0">
                                                        <tr *ngFor="let stops of flight?.stop_data">
                                                            <td class="fw-500 p-1">Onward</td>
                                                            <td *ngIf="flight?.stop_data ">{{stops?.city_name}}</td>
                                                            <td *ngIf="flight?.stop_data "
                                                                [innerHTML]="timeConvert(stops.stop_duration)"></td>
                                                        </tr>
                                                    </ng-container>
                                                    <tr *ngIf="(flight?.stop_data).length == 0">
                                                        <td class="fw-500 p-1">Onward</td>
                                                        <td colspan="2" class="text-center fw-500 p-1">Non-stop</td>
                                                    </tr>
                                                    <ng-container *ngIf="(flight?.return_stop_data).length > 0">
                                                        <tr *ngFor="let restops of flight?.return_stop_data">
                                                            <td class="fw-500 p-1">Return</td>
                                                            <td *ngIf="flight?.return_stop_data != []">
                                                                {{restops?.city_name}}</td>
                                                            <td *ngIf="flight?.return_stop_data != []"
                                                                [innerHTML]="timeConvert(restops.stop_duration)"></td>
                                                        </tr>
                                                    </ng-container>
                                                    <tr
                                                        *ngIf="(flight?.return_stop_data).length == 0 && flight?.is_return == 1">
                                                        <td class="fw-500 p-1">Return</td>
                                                        <td colspan="2" class="text-center fw-500 p-1">Non-stop</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>

            </div>
        </div>
    </div>
</div>
    
    <!-- /***Offline Booking**********/ -->
    <div class="modal fade" id="offlineModle" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Contact Information</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" style="font-size: 16px;">
                    <ul style="list-style-type:none;padding-left:25px;">
                        <li class="mb-2"><span style="font-weight:600;">Address</span>
                            <p class="mb-0">{{getData?.company_name}} <br /> {{getData?.address_2}}
                                {{getData?.address}}, {{getData?.city}} Pincode-{{getData?.zipcode}}</p>
                        </li>
                        <li class="mb-2"><span style="font-weight:600;">Email </span>
                            <p class="mb-0"> <a href="{{getData?.email}}">{{getData?.email}}</a></p>
                        </li>
                        <li class="mb-2"><span style="font-weight:600;">Phone No </span>
                            <p class="mb-0"> +91 {{getData?.mobile}}</p>
                        </li>
                    </ul>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!-- /***Offline Booking**********/ -->

    <!-- confirm booking modal if seat is not available -->
    <div class="modal fade" id="confirmbooking" tabindex="99" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header" style="background-color:#f1f1f1">
                    <button type="button" class="close" data-dismiss="modal"> <span aria-hidden="true">×</span>
                    </button>
                    <div class="col-md-12 p-0">
                        <h4 class="modal-title" style="text-align: center;">Insufficient Tickets</h4>
                    </div>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-sm-12 text-center">
                            <p class="text-center" style="display: inline-flex;"> Only&nbsp; <b>{{aval_seat}}</b>
                                &nbsp;tickets available. To continue booking, change the number of passenger?</p>
                        </div>
                    </div>
                </div>

                <div class="modal-footer border-top text-right">
                    <button type="button" class="btn btn-danger" data-dismiss="modal">Ok</button>
                </div>
            </div>
        </div>
    </div>

    <!--Adults, children, infant detail Modal -->
    <div class="modal fade" id="totalpassengers" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog modal-dialog-centered-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title text-dark" id="exampleModalLabel">Passenger Details</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]="travellers" (ngSubmit)="traveller()">
                    <div class="form-group row text-center">
                        <label for="" class="col-sm-12 col-form-label text-dark ">Adults (12+ years)</label>
                        <div class="col-sm-12 text-center">
                            <div class="btn-group">
                                <label class="btn btn-secondary p-2">
                                    <input type="radio" formControlName="adult" id="adult1" value="1" checked="true"> 1
                                </label>
                                <label class="btn btn-secondary p-2">
                                    <input type="radio" formControlName="adult" id="adult2" value="2"> 2
                                </label>
                                <label class="btn btn-secondary p-2">
                                    <input type="radio" formControlName="adult" id="adult3" value="3"> 3
                                </label>
                                <label class="btn btn-secondary p-2">
                                    <input type="radio" formControlName="adult" id="adult4" value="4"> 4
                                </label>
                                <label class="btn btn-secondary p-2">
                                    <input type="radio" formControlName="adult" id="adult5" value="5"> 5
                                </label>
                                <label class="btn btn-secondary p-2">
                                    <input type="radio" formControlName="adult" id="adult6" value="6"> 6
                                </label>
                                <label class="btn btn-secondary p-2">
                                    <input type="radio" formControlName="adult" id="adult7" value="7"> 7
                                </label>
                                <label class="btn btn-secondary p-2">
                                    <input type="radio" formControlName="adult" id="adult8" value="8"> 8
                                </label>
                                <label class="btn btn-secondary p-2">
                                    <input type="radio" formControlName="adult" id="adult9" value="9"> 9
                                </label>
                                <label class="btn btn-secondary p-2">
                                    <input type="radio" formControlName="adult" id="adult10" value="10"> 10
                                </label>
                                <label class="btn btn-secondary p-2">
                                    <input type="radio" formControlName="adult" id="adult11" value="11"> 11
                                </label>
                                <label class="btn btn-secondary p-2">
                                    <input type="radio" formControlName="adult" id="adult12" value="12"> 12
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row text-center">
                        <label for="" class="col-sm-12 col-form-label text-dark ">Children (2 - 12 years)</label>
                        <div class="col-sm-12 text-center">
                            <div class="btn-group">
                                <label class="btn btn-secondary">
                                    <input type="radio" formControlName="child" id="child0" value="0"
                                        checked="true"><br /> 0
                                </label>
                                <label class="btn btn-secondary">
                                    <input type="radio" formControlName="child" id="child1" value="1"><br /> 1
                                </label>
                                <label class="btn btn-secondary">
                                    <input type="radio" formControlName="child" id="child2" value="2"><br /> 2
                                </label>
                                <label class="btn btn-secondary">
                                    <input type="radio" formControlName="child" id="child3" value="3"><br /> 3
                                </label>
                                <label class="btn btn-secondary">
                                    <input type="radio" formControlName="child" id="child4" value="4"><br /> 4
                                </label>
                                <label class="btn btn-secondary">
                                    <input type="radio" formControlName="child" id="child5" value="5"><br /> 5
                                </label>
                                <label class="btn btn-secondary">
                                    <input type="radio" formControlName="child" id="child6" value="6"><br /> 6
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row text-center">
                        <label for="" class="col-sm-12 col-form-label text-dark ">Infant (Below 2 years)</label>
                        <div class="col-sm-12 text-center">
                            <div class="btn-group">
                                <label class="btn btn-secondary">
                                    <input type="radio" formControlName="infant" id="infant0" value="0"
                                        checked="true"><br /> 0
                                </label>
                                <label class="btn btn-secondary">
                                    <input type="radio" formControlName="infant" id="infant1" value="1"><br /> 1
                                </label>
                                <label class="btn btn-secondary">
                                    <input type="radio" formControlName="infant" id="infant2" value="2"><br /> 2
                                </label>
                                <label class="btn btn-secondary">
                                    <input type="radio" formControlName="infant" id="infant3" value="3"><br /> 3
                                </label>
                                <label class="btn btn-secondary">
                                    <input type="radio" formControlName="infant" id="infant4" value="4"><br /> 4
                                </label>
                                <label class="btn btn-secondary">
                                    <input type="radio" formControlName="infant" id="infant5" value="5"><br /> 5
                                </label>
                                <label class="btn btn-secondary">
                                    <input type="radio" formControlName="infant" id="infant6" value="6"><br /> 6
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer text-center d-block">
                        <button type="submit" class="btn btn-success">Apply</button>
                    </div>
                </form>
            </div>

        </div>
    </div>
    </div>
    <!--End Adults, children, infant detail Modal -->


<ngx-ui-loader></ngx-ui-loader>


<!-- <div id="myNav" class="overlay" >
<a href="javascript:void(0)" class="closebtn" (click)="closeNav()">&times;</a>
<div class="overlay-content" *ngIf="flightdetails">
    <div class="headingFilter"><i class="fa fa-search"></i> Filter <span style="float:right;color:#211ec9;font-size:13px;">Clear All Filter</span> </div>
    <div class="headingFilter"><i class="fa fa-arrow-right"></i> Outbound Flight Times:</div>
    <div class="filterConent">
        <label class="mb-0 text-dark w-100"><input type="checkbox" class=""/> Morning (04:00- 11:00)</label>
        <label class="mb-0 text-dark w-100"><input type="checkbox" class=""/> Afternoon (11:00 - 16:00)</label>
        <label class="mb-0 text-dark w-100"><input type="checkbox" class=""/> Evening (16:00 - 21:00)</label>
        <label class="mb-0 text-dark w-100"><input type="checkbox" class=""/> Night (21:00 - 04:00 AM)</label>
    </div> 
    <div class="headingFilter"><i class="fa fa-arrow-right"></i> Airlines: </div>
    <div class="filterConent">
        <label class="mb-0 text-dark w-100"><input type="checkbox" class=""/> SpiceJet (SG)</label> 
        <label class="mb-0 text-dark w-100" *ngFor="let air of Airlines;let i = index">
            <section class="example-section" >
                <mat-checkbox class="p-1"   [(ngModel)]="air.is_selected"  name="head-bnr3" (change)="filter()" >{{ air.name }}</mat-checkbox>
            </section>
        </label>
    </div> 
    <div class="headingFilter"><i class="fa fa-arrow-right"></i> Stops: </div>
    <div class="filterConent">
        <label class="mb-0 text-dark w-100">No of Stops 
            <section class="example-section" >
                <mat-checkbox class="p-1"  *ngFor="let st of Stops;let i = index" [(ngModel)]="st.is_selected"  name="head-bnr3" (change)="filter()" >{{ st.name }}</mat-checkbox>
            </section>
        </label>
    </div>
    <div class="headingFilter"><i class="fa fa-arrow-right"></i> Destination: </div>
    <div class="filterConent">
        <label class="mb-0 text-dark w-100" *ngFor="let des of Destinations;let i = index" > 
            <section class="example-section" >
                <mat-checkbox class="p-1"  [(ngModel)]="des.is_selected"  name="head-bnr3" (change)="filter()" >{{ des.name }}</mat-checkbox>
            </section>
        </label>            
    </div>
    <div class="headingFilter"><i class="fa fa-arrow-right"></i> Layover: </div>
    <div class="filterConent">
        <label class="mb-0 text-dark mr-2 w-100"><input type="checkbox" class=""/> Ahmedabad(AMD)</label>
        <label class="mb-0 text-dark mr-2 w-100"><input type="checkbox" class=""/> Bengaluru Intl(BLR)</label>
        <label class="mb-0 text-dark mr-2 w-100"><input type="checkbox" class=""/> Calcutta(CCU)</label>
        <label class="mb-0 text-dark mr-2 w-100"><input type="checkbox" class=""/> Chandigarh(IXC)</label>
        <label class="mb-0 text-dark mr-2 w-100"><input type="checkbox" class=""/> Indira Gandhi Airport(DEL)</label>
        <label class="mb-0 text-dark mr-2 w-100"><input type="checkbox" class=""/> Indore(IDR)</label>
        <label class="mb-0 text-dark mr-2 w-100"><input type="checkbox" class=""/> Mumbai(BOM)</label>
        <label class="mb-0 text-dark mr-2 w-100"><input type="checkbox" class=""/> Shamsabad Int. Airport(HYD)</label>
        <label class="mb-0 text-dark mr-2 w-100"><input type="checkbox" class=""/> Sharjah(SHJ)</label>            
    </div>
</div>
</div> -->